// Header.jsx (updated with CheckoutModal import + button)
import React, { useState, useEffect } from "react";
import allImages from "../../../assets/images-import.jsx";
import { useNavbarToggle } from "../../../assets/js/script";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/auth/loginThunk";
import { useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../../services/newUserService.jsx";
import Cookies from "js-cookie";
import { handleErrors } from "../../../utils/errorHandler.jsx";
import CheckoutModal from "./checkoutModel";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userName, setUserName] = useState();
  const [profileImage, setProfileImage] = useState(allImages.Avatar1);

  // NEW: modal open state & user profile object to pass to modal
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({
    userName: "",
    mobileNo: "",
    emailId: "",
  });

  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate("/auth/signin");
  };

  const { handlenavbarClick, isClass } = useNavbarToggle();
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "light" ? "dark" : "light";
      Cookies.set("theme", newTheme);
      return newTheme;
    });
  };

  useEffect(() => {
    const storedTheme = Cookies.get("theme");
    if (storedTheme) {
      setTheme(storedTheme);
    }
    document.documentElement.setAttribute("data-layout-mode", theme);
    document.documentElement.classList.remove(
      "layout-mode-light",
      "layout-mode-dark"
    );
    document.documentElement.classList.add(`layout-mode-${theme}`);
  }, [theme]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await fetchUserProfile();
        const result = userData?.data?.result || {};
        setUserName(result.userName);
        setProfileImage(result.profileImage);
        // populate our local userProfile for the modal (best-effort fields)
        setUserProfile({
          userName: result.userName || "",
          mobileNo: result.mobileNo || result.phone || "",
          emailId: result.emailId || result.email || "",
        });
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchUserData();
  }, []);

  // callback when modal reports payment payload (you can replace with real flow)
  const handlePayment = (payload) => {
    // TODO: call backend/payment gateway here
    console.log("Payment payload from modal:", payload);
    alert(`Simulated payment ₹${payload.totals.payableNow.toFixed(2)}`);
    setIsCheckoutOpen(false);
  };

  return (
    <>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <span className="logo-sm">
                  <img src={allImages.logoSm} alt="" height="40" />
                </span>
                <span className="logo-lg">
                  <img src={allImages.logoDark} alt="" height="40" />
                </span>

                <span className="logo-sm">
                  <img src={allImages.logoSm} alt="" height="40" />
                </span>
                <span className="logo-lg">
                  <img src={allImages.logoLight} alt="" height="40" />
                </span>
              </div>

              <button
                type="button"
                onClick={handlenavbarClick}
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
              >
                <span className={`hamburger-icon ${isClass ? "open" : ""}`}>
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">
              {/* NEW: open checkout button (minimal change to header layout) */}
              <div className="ms-2 header-item">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => setIsCheckoutOpen(true)}
                >
                  Order Generate
                </button>
              </div>
              <div className="ms-1 header-item d-sm-flex">
                <button
                  type="button"
                  onClick={toggleTheme}
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none"
                >
                  <i className="bx bx-moon fs-22"></i>
                </button>
              </div>

              <div className="dropdown ms-sm-3 header-item topbar-user">
                <button
                  type="button"
                  className="btn shadow-none"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src={
                        profileImage ? profileImage : allImages.defaultprofile
                      }
                      alt="Header Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {userName}
                      </span>
                    </span>
                  </span>
                </button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Welcome, {userName}</h6>
                  <a className="dropdown-item" href="/my-profile">
                    <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle">Profile</span>
                  </a>
                  <a className="dropdown-item" href="/change-password">
                    <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle">Change Password</span>
                  </a>
                  <span className="dropdown-item" onClick={handleLogout}>
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle">Logout</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Checkout modal component */}
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setIsCheckoutOpen(false)}
        initialUser={userProfile}
        onPayment={handlePayment}
      />
    </>
  );
};

export default Header;
